import React from 'react';

import { MenuItem, Menu } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import styled from 'styled-components';

import { DotsIcon, EditWeightageIcon, ReplaceIcon } from 'constants/icons';
import theme from 'constants/theme';

import CircularOutlineIcon from 'uiToolkit/CircularOutlineIcon';

const MenuOptions = ({ cloneTag, editTag, deleteTag, renameTag }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleClose = (e, option) => {
    e.stopPropagation();
    setAnchorEl(null);
    switch (option) {
      case 'CLONE':
        cloneTag();
        break;
      case 'EDIT':
        editTag();
        break;
      case 'DELETE':
        deleteTag();

        break;
      case 'RENAME':
        renameTag();
        break;
      default:
        break;
    }
  };

  return (
    <>
      <CircularOutlineIcon onClick={handleClick} color="primary" icon={StyledDotsIcon} />
      <StyledMenu anchorEl={anchorEl} keepMounted open={open} onClose={handleClose} disablePortal>
        <StyledMenuItem onClick={(e) => handleClose(e, 'CLONE')}>
          <FileCopyIcon style={{ fill: theme.palette.icons.dark }} /> Clone
        </StyledMenuItem>
        <StyledMenuItem onClick={(e) => handleClose(e, 'RENAME')}>
          <EditWeightageIcon
            size="fixed12px"
            color={theme.palette.icons.dark}
            style={{ marginLeft: '2px', marginRight: '2px' }}
          />{' '}
          Rename
        </StyledMenuItem>
        <StyledMenuItem onClick={(e) => handleClose(e, 'EDIT')}>
          <ReplaceIcon
            size="fixed12px"
            color={theme.palette.icons.dark}
            style={{ marginLeft: '2px', marginRight: '2px' }}
          />{' '}
          Replace
        </StyledMenuItem>

        <StyledMenuItem onClick={(e) => handleClose(e, 'DELETE')}>
          <DeleteIcon style={{ fill: theme.palette.icons.dark }} /> Delete
        </StyledMenuItem>
      </StyledMenu>
    </>
  );
};

const StyledDotsIcon = styled(DotsIcon)`
  width: 13px;
  margin-top: 1px;
`;

const StyledMenu = styled(Menu)`
  ul {
    padding-top: 10px;
    padding-bottom: 10px;
  }
`;

const StyledMenuItem = styled(MenuItem)`
  padding-right: 30px;
  svg {
    font-size: 1rem;
    margin-right: 0.85rem;
    margin-left: 0.25rem;
    color: #333;
  }
`;

export default MenuOptions;
